import React from 'react';
import PropTypes from 'prop-types';
import DialogWithSuccessLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithSuccessLayout';
import { Button } from '@els/els-react--button';

function ConfirmationSuccessDialog(props) {
  const { selfClose } = props;

  return (
    <DialogWithSuccessLayout
      {...props}
      className="registration-confirmation-success-dialog"
      size="md"
      header="Registration completed successfully"
      headerClassName="rx-border-none"
      footer={
        <div className="els-btn-group-right">
          <Button type="primary" size="small" className="e2e-registration-confirmation-success-ok" onClick={selfClose}>
            Got it
          </Button>
        </div>
      }
      footerClassName="rx-border-none"
    />
  );
}

ConfirmationSuccessDialog.propTypes = {
  selfClose: PropTypes.func.isRequired,
};

export default ConfirmationSuccessDialog;
